import { type ReactElement } from 'react'

import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

// A row is 64px: a 32px media (`size-[32px]`) plus `py-50` (16px top and bottom).
const ROW_HEIGHT_PX = 64

export function DownloadListSkeleton(): ReactElement {
  return (
    <div className="flex flex-col gap-20">
      <Skeleton variant="block" height={ROW_HEIGHT_PX} />
      <Skeleton variant="block" height={ROW_HEIGHT_PX} />
    </div>
  )
}
